<template>
  <div class='memberAdd'>
    <div class='con'>
        <template  v-if="id">
            <div class="text" :style="'background:#'+color">{{contractName.substring(0,1)}}</div>
        </template>
        <template v-else>
            <div style="text-align:center"><img src="@/assets/img/peo3.png" class='text'></div>
        </template>
        <div class="formTxt flex-between" @click="id?'':isShow=true">
            <label class='font18'>亲属关系</label>
            <p class="flex-between"><span>{{contractName||''}}</span>
            <svg-icon icon-class="right" v-if="!id" /></p>
        </div>
        <div class='formTxt flex-between'  @click='optInput("custom","自定义")' v-if="contractName=='自定义'">
          <label class='font18'>自定义</label>
          <p class=" flex-between">
                 <span>{{custom||'最多支持4个汉字'}}</span>
                 <svg-icon icon-class="right" v-if="!id"/>
          </p>
        </div>
        <div class='formTxt flex-between'  @click='optInput("phone","手机号码")'>
          <label class='font18'>手机号码</label>
          <p class=" flex-between">
                 <span>{{phone}}</span>
                 <svg-icon icon-class="right" v-if="!id"/>
          </p>
        </div>
        <div class='formTxt flex-between'>
            <label class='font18'>SOS联系人</label>
            <van-switch v-model="sos" size='.24rem' :disabled='id?true:false'/>
        </div>
        
        <div class="btnFixed"> 
            <template v-if='id'>
                <div class="btn-reset" @click="delectCon">删除</div>
            </template>
            <template v-else>
                <div class="btn-primary" @click="submit" >保存</div>
            </template>
        </div> 
    </div>

    <van-action-sheet v-model="isShow" :lazy-render='false'>
        <van-picker ref = "picker" show-toolbar title='请选择'  :columns="options" 
        @confirm='confirm' @cancel='onCancel' />
    </van-action-sheet>
   

    <van-popup v-model="isInput" class="textPopup">
        <div class="inputCon">
                <p class="title">{{title}}</p>
                <div  class="inputs flex-between">
                    <input v-model="curText" placeholder="请输入手机号码" maxlength="11" v-if="key=='phone'">
                    <input v-model="curText" placeholder="最多支持4个汉字" maxlength="4" v-if="key=='custom'">
                </div>
                <div class='btn'>
                    <p @click="onCancel">取消</p>
                    <p @click="saveText">确定</p>
                </div>
        </div>
    </van-popup>
  </div>
</template>
<script>
import {getKinshipList,contactsAdd,contactsDelete} from "@/api/api.equipment";
  export default {
    data() {
      return {
        phone:this.$route.query.phone||'',
        isSynchronization:false,//是否同步
        id:this.$route.query.id||'',
        contractName:this.$route.query.contractName||'',
        kinship:'',
        options:[],
        color:this.$route.query.color||'',
        sos:false,
        isShow:false,
        isInput:false,
        curText:'',
        key:'',
        custom:'',
        title:'',
      }
    },
   created(){
    
     this.getShip();
     this.sos=this.$route.query.sos==1?true:false;
    },
    methods: {
      submit(){
         if(this.contractName==''&&this.phone==''){
           this.$toast('请完善亲属关系和手机号后再保存');
           return false;
         }else if(this.contractName!=='自定义'&&this.kinship==''){
           this.$toast('请完善亲属关系后再保存');
           return false;
         }else if(this.contractName=='自定义'&&this.custom==''){
           this.$toast('请完善自定义名称后再保存');
           return false;
         }else if(this.phone==''){
           this.$toast('请完善手机号后再保存');
           return false;
         }
         let str=this.options.filter(item=>item.value==this.kinship);
         let params={
                  studentId:this.loginUser.studentId,
                  contractName:this.contractName=='自定义'?this.custom:this.contractName,
                  sos:this.sos?1:0,
                  kinship:this.kinship,
                  phone:this.phone,
                  id:this.id
              };
              contactsAdd(params).then((data) => {
                if (data && data.result) {
                      this.$toast.loading({
                        message: '保存中',
                        forbidClick: true,
                        loadingType: 'spinner',
                        duration:3000,
                      });
                     setTimeout(()=>{
                          this.$router.go(-1);
                      },3000)
                    
                      
                }else{
                  this.loading=false;
                  this.$toast(data.message);
                }
            })
              
        
         
       },
       delectCon(){
         this.$dialog.confirm({
            title:'删除联系人',
            message: '确定删除联系人吗',
            confirmButtonColor:'#E84026',
            confirmButtonText:'删除',
            cancelButtonColor:'0A59F7',
         }).then(() => {
              contactsDelete({
                  phone:this.phone,
                  studentId:this.loginUser.studentId
              }).then((data) => {
                if (data && data.result) {
                    this.$toast.loading({
                      message: '删除中',
                      forbidClick: true,
                      loadingType: 'spinner',
                      duration:3000,
                    });
                     setTimeout(()=>{
                          this.$router.go(-1);
                      },3000)
                    
                }else{
                  this.loading=false;
                  this.$toast(data.message);
                }
              })
         }).catch(() => {
          // on cancel
         });
       },
       optInput(str,title){
            if(this.id) return false;
            this.key=str;
            this.isInput=true;
            this.title=title;
            this.curText=this[str];
       },
       saveText(){
        if(this.key=='phone'){
          this.checkData();
        }else{
          this[this.key]=this.curText;
          this.onCancel();
        }
        
        
        
       },
       //手机号验证
       checkData(){
            let str=this.pubMethod.checkPhone(this.curText);
            if(this.curText&&!str){
                this.$toast('请输入正确手机号码');
            }else{
              this.phone=this.curText;
              this.onCancel();
            }
            
       },
       getShip(){
            if(this.id) return false;
            let arr=[{text:'自定义',value:'00'}];
            getKinshipList({type:2}).then(data=>{
              data.result.forEach(item=>{
                  item.value=item.dictDataCode;
                  item.text=item.dictDataName;
              })
              this.options=data.result.concat(arr);
            })
       },
      confirm(value,index){ 
              if(value.dictDataCode=='00'){
                 this.kinship='';
                 this.contractName='自定义'
              }else{
                  this.kinship=value.value;
                  this.contractName=value.text;
              }
                
                this.onCancel();
        },
       onCancel(){
            this.isShow=false;
            this.isInput=false;
      }
    },
  }
</script>
<style lang="scss" >
.memberAdd{
  padding:.15rem;
  font-size: .16rem;
  .memberSuccess{
    text-align: center;
    padding-top: .62rem;
    .imgs{
      margin-bottom: .15rem;
    }
    .txt{
      font-size: .16rem;
      margin-bottom: .1rem;
    }
    .btn-primary{
      margin-top: .9rem;
      margin-bottom: .2rem;
    }
  }
  .con{
      position: relative;
      .text{
        width:.8rem;
        height:.8rem;
        border-radius:50%;
        margin: .4rem auto;
        line-height: .8rem;
        font-size: .32rem;
        text-align: center;
        color: #fff;
        background: #B7C5D2;
        vertical-align: middle;
      }
      .formTxt{
        background:#fff;
        padding:0rem .12rem;
        border-radius: 8px;
        margin-bottom: .12rem;
        line-height: .48rem;
        color: #666;
        label{
          color:rgba(0,0,0,.9);
        }
      }
      .checkbox{
        margin-top: .1rem;
      }
  }
  .share{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    .bj{
      background: #000;
      opacity: .7;
      height: 100%;
      width: 100%;
    }
    .shareTxt{
      background:url(../../../assets/img/mine/shareBack.png) no-repeat right top;
      position: absolute;
      top: 5px;
      right: 5px;
      padding: 110px 30px 0px 0px;
      color: #fff;
      background-size: 70px;
    }
  }
  
  .van-button--square{
        height: 100%;
  }
  .line{
    line-height: .3rem;
  }
  .wid div:last-child{
    margin-left: .12rem;
  } 
}

</style>